module.exports = __webpack_public_path__ + "img/silver3.169c7d65.png";